import { Injectable, Type } from '@angular/core';
import {
  BaseApiService,
  encodeDates,
} from '@kinet-open-network/client/core/api-client';
import { ItemPrice } from '@kinet-open-network/client/item-prices/data-access';
import {
  IAddItemPrice,
  IDiscount,
  IServPackageOffer,
  IServPackageOfferItem,
  ServiceType,
  ServPackagePriceType,
} from '@kinet-open-network/shared/data-access/model';
import { plainToInstance } from 'class-transformer';
import { map } from 'rxjs';
import { ServPackage } from '../models/serv-package.model';

@Injectable({
  providedIn: 'root',
})
export class ServPackagesService extends BaseApiService<ServPackage> {
  override model: Type<ServPackage> = ServPackage;

  override get endpoint(): string {
    return '/serv-packages';
  }

  getPrices(servPackageId: string, type?: ServPackagePriceType) {
    return this.http
      .get<ItemPrice[]>(`${this.endpoint}/${servPackageId}/pricelist`, {
        params: type ? { type } : undefined,
      })
      .pipe(map((prices) => plainToInstance(ItemPrice, prices)));
  }

  addPrice(
    servPackageId: string,
    type: ServPackagePriceType,
    data: IAddItemPrice,
  ) {
    return this.http
      .post<
        ItemPrice[]
      >(`${this.endpoint}/${servPackageId}/pricelist/${type}`, this.encodePriceData(data))
      .pipe(map((prices) => plainToInstance(ItemPrice, prices)));
  }

  editPrice(
    servPackageId: string,
    type: string,
    priceId: string,
    data: IAddItemPrice,
  ) {
    return this.http
      .put<
        ItemPrice[]
      >(`${this.endpoint}/${servPackageId}/pricelist/${type}/${priceId}`, this.encodePriceData(data))
      .pipe(map((prices) => plainToInstance(ItemPrice, prices)));
  }

  removePrice(servPackageId: string, type: string, priceId: string) {
    return this.http.delete<ItemPrice[]>(
      `${this.endpoint}/${servPackageId}/pricelist/${type}/${priceId}`,
    );
  }

  getDiscounts(servPackageId: string) {
    return this.http.get<IDiscount[]>(
      `${this.endpoint}/${servPackageId}/discounts`,
    );
  }

  getOffers(type: ServiceType) {
    return this.http.get<IServPackageOffer[]>(
      `${this.endpoint}/offers/${type}`,
    );
  }

  getOfferItems(type: ServiceType, offerId: string) {
    return this.http.get<IServPackageOfferItem[]>(
      `${this.endpoint}/offers/${type}/${offerId}/items`,
    );
  }

  private encodePriceData(data: IAddItemPrice): Record<string, any> {
    return encodeDates(data);
  }
}
